<template>
  <section class="section container pt-3">
    <div class="title is-4">{{ $t("access") }}</div>
    <users />
    <roles />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import Users from "./users/Index.vue";
import Roles from "./roles/Index.vue";

export default {
  name: "AccessIndex",
  components: { Users, Roles },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {},
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    this.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
